import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import icOn from '../static/radio_on.svg';
import icOff from '../static/radio_off.svg';
import icDisabled from '../static/radio_disabled.svg';

const wrap: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.color.text,
  cursor: 'pointer',
  '> input': {
    flex: 'none',
    appearance: 'none',
    background: `url(${icOff}) no-repeat center / contain !important`,
    width: 24,
    height: 24,
    margin: 0,
    cursor: 'pointer',
    ':checked': {
      background: `url(${icOn}) no-repeat center / contain !important`,
    },
    ':disabled': {
      background: `url(${icDisabled}) no-repeat center / contain !important`,
      cursor: 'not-allowed',
    },
  },

  ':has(input[type="radio"]:disabled)': {
    color: theme.color.grey300,
  },
};

export { wrap };
